import { RouteCalculatorSettingsServiceInterface } from './interface';
import RouteCalculatorSettingsService from './RouteCalculatorSettingsService';

// Фабрика сервиса настроек
export const routeCalculatorSettingsService: {
  (token?: string): RouteCalculatorSettingsServiceInterface;
} = (token) => {
  return new RouteCalculatorSettingsService(token);
};
